import { find, get, isEmpty, map, some } from 'lodash'

import { TOrder } from '../../../1stlog-ui/src/components/OrderDetails/helpers'
import {
  TOrderEntryShipmentService,
  TOrderEntryShipmentServiceValue,
} from '../../../shipmetrics-shared/containers/OrderEntry/AdditionalServices/types'
import {
  TOrderEntryColi,
  TOrderEntryFormValues,
} from '../../../shipmetrics-shared/containers/OrderEntry/types'
import { TShipmentApiCurrencies } from '../../../shipmetrics-shared/containers/ShipmentApi/types'

export default function makeFormValues(
  order: TOrder, // TOrderDetail,
): TOrderEntryFormValues {
  // console.log('Make form values from', order)

  const allowedPackaging: { id: number; key: string }[] = get(
    global,
    'allowedPackaging',
    [],
  )
  const allowedFreightTerms: { id: number; key: string }[] = get(
    global,
    'allowedFreightTerms',
    [],
  )

  return {
    pickup: { address: {} },

    // TODO: make shipment services
    shipmentServices: map(order.additional_services, (service) => {
      if (!service.name) {
        return null
      }

      const values: TOrderEntryShipmentServiceValue[] = []

      if (service.name === 'COD') {
        values.push({
          name: 'amount',
          type: 'currency',
          value: {
            value: order.cashondeliveryAmount as number,
            currency: order.cashondeliveryCurrency as TShipmentApiCurrencies,
          },
        })
      }

      if (service.name === 'DIS') {
        values.push({
          name: 'dir',
          type: 'input',
          value:
            order.deliveryDriverInformationText ||
            order.pickupDriverInformationText,
        })
      }

      return {
        name: service.name,
        label: service.description,
        isEnabled: true,
        values,
        isSuccess: false, //service.active,
        isError: false, // !service.active,
      }
    }).filter(Boolean) as TOrderEntryShipmentService[],
    valueOfGoods: order.valueOfGoods
      ? {
          value: order.valueOfGoods,
          currency: order.valueOfGoodsCurrency,
        }
      : undefined,
    freightTerms: find(
      allowedFreightTerms,
      (f) => f.id === order.freightTerms_id,
    )?.key,
    colis: order.colis.map((coli) => {
      const coliServices = [
        !isEmpty(coli.hazmat) &&
        some(order.additional_services, (s) => s.name === 'GGS')
          ? {
              name: 'GGS',
              label: i18n.t('hazmat_service', 'Gefahrgutservice'),
              level: 'coli',
              values: [
                {
                  label: undefined,
                  type: 'hazmat',
                  value: coli.hazmat,
                },
              ],
              isEnabled: true,
            }
          : undefined,
      ].filter(Boolean)
      return {
        id: coli.id,
        barcode: coli.barcode1,
        barcode1: coli.barcode1,
        barcode2: coli.barcode2 ?? undefined,
        barcode3: coli.barcode3 ?? undefined,
        width: coli.width,
        length: coli.length,
        height: coli.height,
        weight: coli.weight,
        volume: coli.volume,
        coliReferenceText: coli.coliCustomerReference,
        isCancelled: coli.isCancelled,
        isCancellationAllowed: coli.cancelAllowed,
        packaging: allowedPackaging.find((p) => p.id === coli.packaging_id)
          ?.key,
        services: coliServices,
        content: coli.contentDescription,
      } as TOrderEntryColi
    }),
    customsTerms: order.customsTerms,
    customs: map(order.customs, (item) => ({
      ...item,
      value: {
        value: item.value,
        currency: item.valueCurrency,
      },
    })),
  }
}
